<template>
    <div class="tile"
         v-bind:class="{ 'is-selected' : isSelected }"
         v-bind:style="tileProperty"
         v-on="selectable ? { click: toggleSelect } : {}"
    >
        <a target="_blank"
           v-bind:class="{ 'is-drop-active' : dropActive }"
           v-bind:draggable="draggable"
           v-bind:href="tileUrl"
           v-bind:title="tile.name"
           v-on:contextmenu.prevent.stop="handleRightClick($event)"
           v-on="draggable ? { drop : handleReorder, dragdrop: handleReorder, dragleave: handleDragLeave, dragover: handleDragOver } : {}"
           v-on:dragstart="setDragIcon"

        >
            <img class="tile__image" v-bind:src="'http://kamino.starterio.com' + imageSrc" v-if="tile.image" width="180" height="126" />

            <span class="tile__icon" style="height: 180px;" v-if="!tile.image">
                <svg viewBox="0 0 100 100" v-if="urlObj">
                    <text x="0" y="20" textLength="75"
                          v-bind:style="tileFillProperty"
                          v-if="urlObj.subdomain">{{ urlObj.subdomain }}.
                    </text>
                    <text x="0" v-bind:y="30 + (7 / urlObj.domain.length * 24) / 2" textLength="100"
                          v-bind:font-size="7 / urlObj.domain.length * 24"
                          v-bind:style="tileFillProperty"
                          v-if="urlObj.domain">{{ urlObj.domain }}
                    </text>
                    <text x="50" v-bind:y="45 + (7 / urlObj.domain.length * 24) / 2" textLength="40"
                          v-bind:style="tileFillProperty"
                          v-if="urlObj.tld && urlObj.domain">.{{ urlObj.tld }}
                    </text>
                </svg>
            </span>

            <span class="tile__name vertically-centered" v-bind:style="textColorProperty"><div>{{ tile.name/*.substr(0, numberOfVisibleCharacters) }}{{ tile.name.length > numberOfVisibleCharacters ? '...' : ''*/ }}</div></span>
            <!--<span class="tile__name tile__name__helper" v-bind:style="textColorProperty" v-if="tile.name.length > numberOfVisibleCharacters">{{ tile.name }} </span>-->

            <span class="tile__actions" v-if="user && showActions">
                <a class="tile__action tile__action--select" href="javascript: void(0);"
                   v-if="showSelectAction"
                   v-on:click.prevent="toggleSelect"
                >
                    <span class="jam jam-check"></span>
                </a>
                <router-link class="tile__action tile__action--edit"
                             v-bind:to="{ name: 'tiles.edit', params: { tile: tile.id } }"
                >
                    <span class="jam jam-pencil"></span>
                </router-link>
                <a class="tile__action tile__action--delete" href="javascript: void(0);"
                   v-if="this.user"
                   v-on:click.prevent="openDeleteConfirmModal('delete-tile-' + tile.id)"
                >
                    <span class="jam jam-close"></span>
                </a>
            </span>
        </a>
        <confirm-modal
                v-bind:id="'delete-tile-' + tile.id"
                v-bind:text="__('Are you sure you wish to delete this tile?')"
        ></confirm-modal>
        <move-tile
                v-bind:id="'move-tile-' + tile.id"
                v-bind:tile="tile"
        ></move-tile>
        <copy-tile
                v-bind:id="'copy-tile-' + tile.id"
                v-bind:tile="tile"
        ></copy-tile>
        <add-tile-to-link-collection
                v-bind:id="'add-tile-to-link-collection-' + tile.id"
                v-bind:tile="tile"
        ></add-tile-to-link-collection>
        <context-menu
                v-bind:elementId="'tileContextMenu' + tile.id"
                v-bind:options="contextMenuOptions"
                v-bind:ref="'contextMenu' + tile.id"
                v-if="showActions"
                v-on:optionClicked="handleContextMenuClick"
        ></context-menu>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import confirmModal from '../elements/ConfirmModal.vue';
    import contextMenu from '../elements/ContextMenu.vue';
    import moveTile from '../components/MoveTile.vue';
    import copyTile from '../components/CopyTile.vue';
    import addTileToLinkCollection from '../components/AddTileToLinkCollection.vue'

    export default {
        components: {
            confirmModal,
            contextMenu,
            moveTile,
            copyTile,
            addTileToLinkCollection
        },
        computed: {
            eventHandlerProperty: function () {
                let obj = {};

                if (this.draggable) {
                    obj.dragend = this.handleReorder;
                }
                if (this.selectable) {
                    obj.click = this.toggleSelect;
                }

                return obj;
            },
            iconHeightProperty: function () {
                return 'height: ' + (this.tileWidth * 70 / 100) + 'px;';
            },
            imageSrc: function () {
                return this.tile.image ? '/media/tiles/' + this.tile.image : null;
            },
            numberOfVisibleCharacters: function () {
                return (this.tileWidth - 20) * 18 / 80;
            },
            textBackground: function () {
                return this.tile.text_background || '#ffffff';
            },
            textColor: function () {
                return this.tile.text_color || '#333449';
            },
            textColorProperty: function () {
                return 'background-color: ' + this.textBackground + '; color: ' + this.textColor + ';';
            },
            tileBackground: function () {
                return this.tile.tile_background || '#f0f3fa';
            },
            tileColor: function () {
                return this.tile.tile_color || '#ffffff';
            },
            tileFillProperty: function () {
                return 'fill: ' + this.tileColor + ';';
            },
            tileProperty: function () {
                const tileHeight = (this.tileWidth * 70 / 100) + 40;
                return 'background-color: ' + this.tileBackground + '; height: ' + tileHeight + 'px; width: ' + this.tileWidth + 'px;';
            },
            tileWidthProperty: function () {
                return 'width: ' + this.tileWidth + 'px;';
            },
            tileUrl: function () {
                 return !this.selectable ? (this.tile.is_affiliate ? this.appUrl + '/go/' + this.slug(this.tile.name) + '/' + this.tile.id  : (this.tile.url.includes('http') ? this.tile.url : 'http://' + this.tile.url)) : null;
            },
            urlObj: function () {
                try {
                    let url = this.tile.url;

                    // add protocol if not present
                    if (!url.match(/^[a-zA-Z]+:\/\//)) {
                        url = 'https://' + url;
                    }

                    const urlObj = new URL(url);
                    const urlArr = urlObj.hostname.split('.', -2).reverse();

                    return {
                        domain: urlArr[1],
                        subdomain: (urlArr[2] && urlArr[2] != 'www') ? urlArr[2] : null,
                        tld: urlArr[0]
                    };
                } catch (e) {
                    return {};
                }
            }
        },
        created: function () {
            // attach event listeners
            eventBus.$on('confirm', this.handleDelete);
            eventBus.$on('deselect-all-tiles', this.deselect);
            eventBus.$on('select-all-tiles', this.select);

            // init context menu
            if (this.user) {
                this.contextMenuOptions = [
                    {
                        name: 'Edit',
                        slug: 'edit'
                    },
                    {
                        name: 'Delete',
                        slug: 'delete'
                    },
                    {
                        name: 'Move to startdesk',
                        slug: 'move'
                    },
                    {
                        name: 'Copy to startdesk',
                        slug: 'copy'
                    }
                ];

                if (this.user.is_admin) {

                    this.contextMenuOptions.push({
                        name: 'Add to link collection',
                        slug: 'link'
                    });
                }
            }
        },
        data: function () {
            return {
                dropActive: false,
                isSelected: false,
                contextMenuOptions: []
            }
        },
        methods: {
            deselect: function () {
                if (this.isSelected == true) {
                    this.isSelected = false;

                    this.$parent.selectedTiles = this.$parent.selectedTiles.filter(function (tile) {
                        return this.tile != tile;
                    }.bind(this));
                }
            },
            handleContextMenuClick: function(event) {
                if (event.option.slug == 'edit') {
                    this.$router.push({
                        name: 'tiles.edit',
                        params: { tile: event.item.id }
                    });
                } else if (event.option.slug == 'delete') {
                    this.openDeleteConfirmModal('delete-tile-' + event.item.id);
                } else if (event.option.slug == 'move') {
                    eventBus.$emit('open-modal', 'move-tile-' + event.item.id);
                } else if (event.option.slug == 'copy') {
                    eventBus.$emit('open-modal', 'copy-tile-' + event.item.id);
                } else if (event.option.slug == 'link') {
                    eventBus.$emit('open-modal', 'add-tile-to-link-collection-' + event.item.id);
                }

            },
            handleDragLeave: function(event) {
                this.dropActive = false;
                event.preventDefault();
            },
            handleDragOver: function(event) {
                this.dropActive = true;
                event.preventDefault();
            },
            handleReorder: function(event) {
                this.dropActive = false;

                const id = event.dataTransfer.getData('text');

                this.$parent.handleReorder(id, this.tile.id);
            },
            handleRightClick: function(event) {
                if (this.showActions) {
                    this.$refs['contextMenu' + this.tile.id].showMenu(event, this.tile);
                }
            },
            handleDelete: function (id) {
                if (
                    id == 'delete-tile-' + this.tile.id
                    || (
                        id == 'delete-selected-tiles'
                        && this.$parent.selectedTiles.indexOf(this.tile) !== -1
                    )
                ) {
                    eventBus.$emit('show-loader');

                    this.$http.delete(this.apiUrl + '/tiles/' + this.tile.id).then(function (response) {
                        this.$parent.paging.to--;
                        this.$parent.paging.total--;

                        this.$parent.selectedTiles = this.$parent.selectedTiles.filter(function (tile) {
                            return this.tile != tile;
                        }.bind(this));

                        this.$parent.tiles = this.$parent.tiles.filter(function (tile) {
                            return this.tile.id != tile.id
                        }.bind(this));
                        
                        if (this.tile && this.tile.startdesk_id && this.tile.startdesk_id != '') {
                            setTimeout(function () {
                                this.$http.post(this.apiUrl + '/startdesks/' + this.tile.startdesk_id + '/screenshot');
                            }.bind(this), 1000);
                        }
                        
                        eventBus.$emit('hide-loader');
                    }.bind(this), function (response) {
                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors sending data to server.')
                        );

                        eventBus.$emit('hide-loader');
                    });
                }
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            select: function () {
                if (this.isSelected == false) {
                    this.isSelected = true;

                    this.$parent.selectedTiles.push(this.tile);
                }
            },
            setDragIcon: function (event) {
                event.stopPropagation();

                const el = event.currentTarget;

                event.dataTransfer.setData('text/plain', this.tile.id);
                event.dataTransfer.setDragImage(el, 10, 10);
            },
            slug: function(str) {
                var slug = "";
                // Change to lower case
                var strLower = str.toLowerCase();
                // Letter "e"
                slug = strLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
                // Letter "a"
                slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
                // Letter "o"
                slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
                // Letter "u"
                slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
                // Letter "d"
                slug = slug.replace(/đ/gi, 'd');
                // Trim the last whitespace
                slug = slug.replace(/\s*$/g, '');
                // Change whitespace to "-"
                slug = slug.replace(/\s+/g, '-');

                return slug;
            },
            toggleSelect: function () {
                this.isSelected = !this.isSelected;

                if (this.isSelected) {
                    this.$parent.selectedTiles.push(this.tile);
                } else {
                    this.$parent.selectedTiles = this.$parent.selectedTiles.filter(function (tile) {
                        return this.tile != tile;
                    }.bind(this));
                }
            }
        },
        props: {
            draggable: {
                default: false,
                type: Boolean
            },
            selectable: {
                default: false,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            },
            showSelectAction: {
                default: false,
                type: Boolean
            },
            tile: {
                required: true,
                type: Object
            },
            tileWidth: {
                required: true,
                type: Number
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Tile.vue